"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const filter_1 = __importDefault(require("lodash/filter"));
const find_1 = __importDefault(require("lodash/find"));
const forEach_1 = __importDefault(require("lodash/forEach"));
const get_1 = __importDefault(require("lodash/get"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
const join_1 = __importDefault(require("lodash/join"));
const keys_1 = __importDefault(require("lodash/keys"));
const map_1 = __importDefault(require("lodash/map"));
const pickBy_1 = __importDefault(require("lodash/pickBy"));
const size_1 = __importDefault(require("lodash/size"));
const mobx_1 = require("mobx");
const getAddOnList_1 = __importDefault(require("../clients/addon/getAddOnList"));
const API_STATE_1 = __importDefault(require("../constants/app/API_STATE"));
const UNLIMITED_KM_1 = __importDefault(require("../constants/app/UNLIMITED_KM"));
const addOnFactory_1 = __importDefault(require("../factories/addon/addOnFactory"));
const getAddOnNotFound_1 = __importDefault(require("../utils/error/getAddOnNotFound"));
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**
 * AddOn Domain Store
 * Stores a list of Addons.
 */
class AddOnStore {
    constructor(initialState, $env) {
        this.addOnState = {};
        this.appliedAddOnState = {};
        this.data = [];
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Initialize AddOn methods
         */
        this.initalizeAddOn = () => {
            this.initializeAddOnState();
        };
        /**
         * Fetch AddOn data from backend
         * @param errorHandler { function}
         */
        this.fetch = (0, mobx_1.flow)(function* (quoteId, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = [];
                this.errorData = {};
                this.addOnState = {};
                this.appliedAddOnState = {};
                // make the api call
                const addOnResponse = yield (0, getAddOnList_1.default)(quoteId);
                // for no data (0) response comes back with only total
                if ((0, size_1.default)(addOnResponse) < 1) {
                    // throw custom error
                    const errObj = (0, getAddOnNotFound_1.default)();
                    this.onError(errObj, errorHandler);
                }
                else {
                    this.onSuccess(addOnResponse);
                }
            }
            catch (err) {
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param {Array<AddOnType>} data
         */
        this.onSuccess = (data) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
        };
        /**
         * on error callback
         * @param {AxiosError} err
         * @param {ErrorHandlerType} errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * construct the addOnstate from addOn data
         */
        this.initializeAddOnState = () => {
            const addOnStateObj = {};
            (0, forEach_1.default)(this.data, (addOn) => {
                const id = (0, get_1.default)(addOn, 'id');
                addOnStateObj[id] = false;
            });
            this.addOnState = addOnStateObj;
            this.confirmAddOn();
        };
        /**
         * Update addOn state
         * @param {number} id
         * @param {boolean} value
         * @param {string} filterType
         */
        this.updateAddOnState = (id, value) => {
            // mutate addOnState state observable
            this.addOnState = Object.assign(Object.assign({}, this.addOnState), { [id]: value });
        };
        /**
         * Action to be called when click on confirm AddOn
         */
        this.confirmAddOn = () => {
            this.appliedAddOnState = Object.assign({}, this.addOnState);
        };
        /**
         * Discard current addOn changes
         */
        this.discardAddOns = () => {
            this.addOnState = Object.assign({}, this.appliedAddOnState);
        };
        /**
         * Map initial state to store state
         * @param {InitialStateStoreType<InsuranceType>} initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
    }
    /**
     * Returns true if addOn has changed from last applied state
     * Used for close button
     */
    get hasAddOnChanged() {
        return !(0, isEqual_1.default)(this.appliedAddOnState, this.addOnState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFialed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns true if API fetch returned no data
     * @returns {Boolean}
     */
    get hasNoData() {
        return this.isSuccess && this.count === 0;
    }
    /**
     * Returns total branch count
     * @returns {Number}
     */
    get count() {
        return (0, size_1.default)(this.addOnList);
    }
    /**
     * Returns current config language
     * @returns {LANG_VALUES}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**
     * Returns formatted addOn List
     * @returns {Array<AddOnFactoryType>}
     */
    get addOnList() {
        return (0, map_1.default)(this.data, (addOn) => (0, addOnFactory_1.default)(addOn, this.language));
    }
    /**
     * Returns formatted addOn List without unlimited Km
     * @returns {Array<AddOnFactoryType>}
     */
    get addOnListWithoutUnlimitedKm() {
        return (0, filter_1.default)(this.addOnList, (addOn) => {
            const addOnCode = (0, get_1.default)(addOn, 'code');
            return addOnCode !== UNLIMITED_KM_1.default;
        });
    }
    /**
     * Returns Unlimited Km.
     * @returns {Object<AddOnFactoryType>}
     */
    get unlimitedKmAddon() {
        return (0, find_1.default)(this.addOnList, (addOn) => {
            const addOnCode = (0, get_1.default)(addOn, 'code');
            return addOnCode === UNLIMITED_KM_1.default;
        });
    }
    /**
     * Returns true if has Unlimited Km.
     * @returns {Boolean}
     */
    get hasUnlimitedKm() {
        return !!this.unlimitedKmAddon;
    }
    /**
     * Returns selected formatted addOn List
     * @returns {Array<AddOnFactoryType>}
     */
    get mapSelectedAddOnList() {
        return (0, filter_1.default)(this.addOnList, (addOn) => {
            return (0, get_1.default)(this.appliedAddOnState, `${addOn.id}`);
        });
    }
    /**
     * Returns selected Unlimited Km.
     * @returns {Object<AddOnFactoryType>}
     */
    get seletedUnlimitedKm() {
        return (0, find_1.default)(this.mapSelectedAddOnList, (addOn) => {
            const addOnCode = (0, get_1.default)(addOn, 'code');
            return addOnCode === UNLIMITED_KM_1.default;
        });
    }
    /**
     * Returns true if Unlimited Km selected.
     * @returns {Boolean}
     */
    get isUnlimitedKmSeleted() {
        return !!this.seletedUnlimitedKm;
    }
    /**
     * Returns true if Unlimited Km removed.
     * @returns {Boolean}
     */
    get isUnlimitedKmRemoved() {
        const unlimitedKmId = (0, get_1.default)(this.seletedUnlimitedKm, 'id');
        const hasUnlimitedKm = this.selectedAddOns.includes(String(unlimitedKmId));
        return this.isUnlimitedKmSeleted && !hasUnlimitedKm;
    }
    /**
     * Returns all addOns name concatenate in single string
     * eg: 'GCC Permit and Baby Seat'
     * @returns {String}
     */
    get addOnByName() {
        return (0, join_1.default)((0, map_1.default)(this.addOnList, (addOn) => (0, get_1.default)(addOn, 'name', '')), ', ');
    }
    /**
     * Return confirmed addOns name concatenate in single string
     * eg 'GCC Permit & Baby Seat'
     * @returns {String}
     */
    get confirmedAddOnsByName() {
        const selectedAddOns = (0, filter_1.default)(this.addOnList, (addOn) => (0, get_1.default)(this.appliedAddOnState, `${addOn.id}`));
        return (0, join_1.default)((0, map_1.default)(selectedAddOns, (addOn) => (0, get_1.default)(addOn, 'name', '')), ' & ');
    }
    /**
     * Return confirmed addOns code concatenate in single string
     * eg 'GCC & 2'
     * @returns {String}
     */
    get confirmedAddOnsByCode() {
        const selectedAddOns = (0, filter_1.default)(this.addOnList, (addOn) => (0, get_1.default)(this.addOnState, `${addOn.id}`));
        return (0, join_1.default)((0, map_1.default)(selectedAddOns, (addOn) => (0, get_1.default)(addOn, 'code', '')), ' & ');
    }
    /**
     * Returns selected add ons
     * @returns {Array}
     */
    get selectedAddOns() {
        return (0, keys_1.default)((0, pickBy_1.default)(this.addOnState, (val) => val));
    }
    /**
     * Returns selected add ons count
     * @returns {number}
     */
    get selectedAddOnsCount() {
        return (0, size_1.default)(this.selectedAddOns);
    }
}
__decorate([
    mobx_1.observable
], AddOnStore.prototype, "addOnState", void 0);
__decorate([
    mobx_1.observable
], AddOnStore.prototype, "appliedAddOnState", void 0);
__decorate([
    mobx_1.observable
], AddOnStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], AddOnStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], AddOnStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "hasAddOnChanged", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "hasFialed", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "hasNoData", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "count", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "addOnList", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "addOnListWithoutUnlimitedKm", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "unlimitedKmAddon", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "hasUnlimitedKm", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "mapSelectedAddOnList", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "seletedUnlimitedKm", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "isUnlimitedKmSeleted", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "isUnlimitedKmRemoved", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "addOnByName", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "confirmedAddOnsByName", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "confirmedAddOnsByCode", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "selectedAddOns", null);
__decorate([
    mobx_1.computed
], AddOnStore.prototype, "selectedAddOnsCount", null);
__decorate([
    mobx_1.action.bound
], AddOnStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], AddOnStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], AddOnStore.prototype, "initializeAddOnState", void 0);
__decorate([
    mobx_1.action.bound
], AddOnStore.prototype, "updateAddOnState", void 0);
__decorate([
    mobx_1.action.bound
], AddOnStore.prototype, "confirmAddOn", void 0);
__decorate([
    mobx_1.action.bound
], AddOnStore.prototype, "discardAddOns", void 0);
exports.default = AddOnStore;
